<template>
  <div class="audio-process">
    <ul class="audio-process-list">
      <li
        v-for="(p, i) in processList"
        :key="i"
        :class="{
          'process-active': !!p && i > 6,
          'process-active-six': !!p && i <= 6,
          'process-active-five': !!p && i <= 5,
          'process-active-four': !!p && i <= 4,
          'process-active-three': !!p && i <= 3,
          'process-active-two': !!p && i <= 2,
          'process-active-one': !!p && i <= 1,
        }"
      ></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'audioProcess',
  data() {
    return {
      processList: [],
      mic: null,
      context: null,
      script: null
    };
  },
  computed: {
    liveConfig() {
      return this.$store.getters.liveConfig;
    },
    mediaStatus() {
      return this.$store.getters.mediaStatus
    },
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    audioInputDeviceId() {
      return this.$store.getters.AudioInputDeviceId;
    },
    publishLocal() {
      let publishLocal = null;
      if (
        this.rtcClient &&
        this.rtcClient.RTCRoom &&
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal
      ) {
        publishLocal = this.rtcClient.RTCRoom.webrtc.publishLocal;
      }
      return publishLocal;
    },
    publishStream() {
      let pubStream = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal &&
        this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream
      ) {
        pubStream = this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream;
      }
      return pubStream;
    },
    audioStatus() {
      return this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.mediaStatus
        ? this.$store.getters.selfParticipant.mediaStatus.audio
        : "disabled";
    },
  },
  mounted() {
    if (this.publishLocal && this.publishLocal.publishStream && !this.isLoadVideoStream) {
      this.initProcess();
    }
    Bus.$on('ondevicechange', () => {
      this.initProcess();
    })
  },
  watch: {
    publishLocal: {
      deep: true,
      handler(val) {
        if (val.publishStream) {
          this.initProcess();
        }
      }
    },
    audioInputDeviceId: {
      deep: true,
      handler(n) {
        this.initProcess();
      }
    }
  },
  methods: {
    async initProcess() {
      if (!this.publishStream || !this.publishStream.getAudioTracks().length) {
      console.warn('No audio tracks found in publishStream');
      return;
    }
      this.processList = [];
      for (let i = 0; i < 10; i++) {
        this.processList.push(false);
      }
      this.getProcess();
    },
    async getProcess() {
      await this.$nextTick();
      if (!(this.publishStream instanceof MediaStream)) return;
      try {
        this.stopAudioContext();
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
        this.context = new AudioContext();
        this.mic = this.context.createMediaStreamSource(this.publishStream);
        this.script = this.context.createScriptProcessor(2048, 1, 1);
        this.mic.connect(this.script);
        this.script.connect(this.context.destination);
        this.script.onaudioprocess = (event) => {
          const input = event.inputBuffer.getChannelData(0);
          let inputsum = 0.0;
          for (let i = 0; i < input.length; ++i) {
            inputsum += input[i] * input[i] * 5;
          }
          this.inputInstant = parseInt(Math.sqrt(inputsum / input.length) * 100);
          this.$store.commit('SET_INPUTINSTANT', this.inputInstant);
          this.setProcessList();
        };
      } catch (error) {
        console.error(error);
      }
    },
    setProcessList() {
      let isActive = parseInt(this.inputInstant / 5);
      this.processList = [];
      for (let i = 0; i < 10; i++) {
        if (i < isActive) {
          if (this.audioStatus == 'active') {
            // 开启插播时不要音量动画
            if (this.liveConfig?.liveondemandVoiceStatus === 0 && (this.mediaStatus == 2 || this.mediaStatus == 3)) {
              this.processList.push(false);
            } else {
              this.processList.push(true);
            }
          } else {
            this.processList.push(false);
          }
        } else {
          this.processList.push(false);
        }
      }
    },
    stopAudioContext() {
      if (this.mic) {
        this.mic.disconnect();
        this.mic = null;
      }
      if (this.script) {
        this.script.disconnect();
        this.script = null;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.audio-process {
  position: absolute;
  right: 20px;
  bottom: 5px;
  z-index: 1000;
}
.audio-process-list {
  display: flex;
  justify-content: space-around;
  margin: 0px;
  flex-direction: column-reverse;
  height: 64px;
  li {
    display: inline-block;
    width: 10px;
    height: 5px;
    background-color: #61605f;
  }
  .process-active {
    background-color: #7BDE64;
  }
  .process-active-six {
    background-color: #A7E467;
  }
  .process-active-five {
    background-color: #DBFF3C;
  }
  .process-active-four {
    background-color: #FFFB3A;
  }

  .process-active-three {
    background-color: #F5D22E;
  }
  .process-active-two {
    background-color: #F5B52E;
  }
  .process-active-one {
    background-color: #F5812E;
  }
}
</style>
